import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn } from '@angular/router';
import { Observable } from 'rxjs';

// Services
import { CommonService } from '../../services/common/common.service';
import { LoggerService } from '../../services/logger/logger.service';
import { NetworkService } from '../../services/network/network.service';
import { OfflineService } from '../../services/offline/offline.service';
import { PwaService } from '../../services/pwa/pwa.service';

export const AuthenticationGuard: CanActivateFn = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const HOME = '/home';
  const logger = inject(LoggerService);
  const common = inject(CommonService);
  const network = inject(NetworkService);
  const offline = inject(OfflineService);
  const pwa = inject(PwaService);

  return new Observable((observer) => {
    common.getPlatform();
    pwa.checkIfRunningInIncognito();

    const { url } = state;
    logger.consoleLog('AuthenticationGuard', 'canActivate', {
      url,
      previousUrl: network.previousUrl,
    });
    offline.getOfflineFile('AuthenticationGuard 38', url === HOME);

    observer.next(true);
  });
};
